import { createSVGPoint } from "./createSVGPoint.js";
export const getCenterPointInViewPort = (svg_el) => (el) => {
  const bbox = el.getBBox();
  const ctm = el.getCTM();
  if (ctm == null) {
    return null;
  }
  return createSVGPoint(svg_el)([
    bbox.x + bbox.width / 2,
    bbox.y + bbox.height / 2,
  ]).matrixTransform(ctm);
};
